import { PlutoClientException } from '@/PlutoClientException';

export function rethrowIfNotClientException(error: unknown) {
  if (error instanceof PlutoClientException) {
    console.log(error.toString());
  } else {
    throw error;
  }
}
